import Vue from 'vue';
import VModal from 'vue-js-modal';

Vue.use(VModal);

// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald-loader" */ 'components/Loader')
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Text')
);
Vue.component('ald-modal', () =>
  import(/* webpackChunkName: "components/ald-modal" */ 'components/Modal')
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald-markdown" */ 'components/Markdown')
);
